module.exports = __webpack_public_path__ + "static/img/110121.2807445f.png";